// Centralized file upload limits and constants
//
// SYNC NOTE: When adding a new file extension, update TWO places only:
//   1. ALLOWED_FILE_EXTENSIONS below (frontend source of truth)
//      fileUploadHandler.js imports from here — no separate list to update
//   2. photon_ai_be/services/files/file_constants.py → FileConstants (backend source of truth)
//
// NOTE: video/* and audio/* are intentionally kept as wildcards (not listed in
// ALLOWED_FILE_EXTENSIONS) — same pattern as image/*. Backend video/audio
// extensions are maintained in file_constants.py VIDEO_EXTENSIONS / AUDIO_EXTENSIONS.
//
// Tier 2 context gate (LARGE_FILE_BYTE_THRESHOLD = 2MB) lives in file_constants.py only
// — it is a backend-only concern (LLM token limit routing, not upload validation).

// =====================
// ALLOWED FILE EXTENSIONS
// =====================

// Centralized allowed file extensions for uploads
export const ALLOWED_FILE_EXTENSIONS = [
  "pdf", "csv", "docx", "txt", "xlsx", "doc", "heic", "heif", "dcm", "dicom", "dicm", "xls", "md", "log", "svg"
];

// Centralized accept string for file input
export const ALLOWED_FILE_ACCEPT_STRING =
  "." + ALLOWED_FILE_EXTENSIONS.join(",." ) + ",image/*,video/*,audio/*";

// Image extensions (for specific image checks)
export const imageExtensions = [
  "heic",
  "heif",
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
];

export const videoExtensions = ["mp4", "mov", "avi", "webm", "mkv", "m4v"];

export const audioExtensions = ["mp3", "wav", "m4a", "ogg", "flac", "aac"];

// =====================
// CHAT FILE UPLOAD LIMITS
// =====================

// Maximum number of files that can be uploaded at once (per chat/session)
export const MAX_FILE_COUNT = 10;

// Maximum total size (in MB) for all uploaded files combined
export const MAX_TOTAL_SIZE_MB = 250;

// Maximum size (in MB) for a single file
export const MAX_SINGLE_FILE_SIZE_MB = 25;

// =====================
// SPECTRA FILE UPLOAD LIMITS
// =====================

// For Spectra: maximum number of files allowed
export const SPECTRA_MAX_FILE_COUNT = 1000;

// For Spectra: maximum total size (in MB) for all uploaded files combined
export const SPECTRA_MAX_TOTAL_SIZE_MB = 2000;

// For Spectra: maximum size (in MB) for a single file
export const SPECTRA_MAX_SINGLE_FILE_SIZE_MB = 25;
